import { apolloClient } from '../apolloClient'
import { UNSUBSCRIBE_FROM_RAFFLE } from './mutations/UNSUBSCRIBE_FROM_RAFFLE'
import { setGlobal } from 'reactn'

export const unsubscribeFromRaffle = async (id: String) => {
  const response = await apolloClient.mutate({
    mutation: UNSUBSCRIBE_FROM_RAFFLE,
    variables: {
      raffleId: id,
    },
  })

  await setGlobal({
    shouldRefreshRaffles: true,
  })
}
